<template>
    <div class="tuce hml_whplt">
        <div class="back" @click="backClick">
            <img src="@/assets/svg/details/back_white.svg" alt="">
        </div>
        <div class="addImg" @click="addImgClick">
            <img src="@/assets/svg/details//mock.svg">
        </div>
        <div class="tuceSwiper swiper-container">
            <ul class="swiper-wrapper">
                <li class="swiper-slide"
                v-for="(item,index) in imgArray"
                :key="index"
                >
                <img :src="item" alt="">
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";
import 'swiper/css/swiper.css';
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
export default {
    data() {
        return {
            imgArray: []
        }
    },
    created(){
        let currentData = this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].list[this.levelThreeIndex];
        let imgArray = currentData.images.replace(/\n/g,"").split("<br />");
        imgArray.forEach((item,index) => {
            if(item.length > 10 && item.indexOf("gps") == -1){
                if(item.split("|")[2]){
                    this.getImgSrc(item.split("|")[2],1).forEach((value,ind) => {
                        this.imgArray.push(value);
                    });
                }
                
            }
        });
        console.log(this.imgArray);
    },
    mounted(){
        const _this = this;
        this.swiper = new Swiper('.tuceSwiper',{
           initialSlide: _this.tuceIndex
        });
    },
    methods: {
        backClick(){
            this.$router.push("/panorama");
        },
        addImgClick(){
            this.$router.push("/tuceList");
        },
    },
    computed: {
        ...publicData.mapState(["firstLevelIndex","allData","secondLevelIndex","levelThreeIndex","tuceIndex"])
    },
}
</script>

<style lang="scss" scoped>
.tuce{
    background: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    .back{
        width: .24rem;
        height: .4rem;
        position: absolute;
        left: 0;
        top: 0;
        -webkit-box-sizing: content-box;
        box-sizing: content-box;
        padding: .3rem;
        z-index: 10;
        img{
            transform: rotate(180deg);
        }
    }
    .addImg{
        width: .4rem;
        height: .4rem;
        position: absolute;
        right: 0;
        top: 0;
        box-sizing: content-box;
        padding: .3rem .3rem 0 0;
        z-index: 10;
    }
}
</style>